import {DateInput} from "react-admin";
import {EditPopup} from "../../../components/Admin/Pages/EditPopup/EditPopup";
import {seasonService} from "../../../services/seasonService";

export const SeasonEdit = () => {
  return (
    <EditPopup updateQuery={seasonService.update} getRecordQuery={seasonService.getById}>
      <DateInput source="startDate" fullWidth/>
    </EditPopup>
  );
};